export enum Pages {
  SCANNER = "scanner",
  PRODUCTS = "products",
}
